// extracted by mini-css-extract-plugin
export default {"wrapper":"M_SocialInput_wrapper__tACa+"};